import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { HERO_IMG } from "@/components/landing/landingData";

const LINKS = [["Explore Dashboards", "dashboards"], ["Features", "features"], ["Pricing", "pricing"]];

export const scrollToId = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

export const GreenButton = ({ children, className = "", ...rest }) => (
  <button {...rest}
    className={`inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-cyan-400 to-blue-500 px-6 py-3 font-mono text-xs font-bold uppercase tracking-[0.18em] text-slate-950 shadow-[0_0_28px_rgba(34,211,238,0.35)] transition-[transform,box-shadow,filter] duration-200 hover:-translate-y-0.5 hover:brightness-110 hover:shadow-[0_0_40px_rgba(34,211,238,0.5)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#22D3EE] focus-visible:ring-offset-2 focus-visible:ring-offset-black ${className}`}>
    {children}
  </button>
);

export const GhostButton = ({ children, className = "", ...rest }) => (
  <button {...rest}
    className={`inline-flex items-center justify-center gap-2 rounded-full border border-white/15 px-6 py-3 font-mono text-xs font-bold uppercase tracking-[0.18em] text-white transition-[border-color,background-color] duration-200 hover:border-[#22D3EE]/60 hover:bg-[#22D3EE]/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#22D3EE] ${className}`}>
    {children}
  </button>
);

export const LandingHeader = ({ onSignIn, onFree }) => {
  const [open, setOpen] = useState(false);
  const go = (id) => { setOpen(false); setTimeout(() => scrollToId(id), 60); };
  return (
    <header data-testid="lp-header" className="sticky top-0 z-40 border-b border-white/5 bg-[#03050A]/75 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6">
        <button data-testid="lp-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3" aria-label="Hat Trick home">
          <img src={HERO_IMG} alt="QSI HAT TRICK" className="h-10 w-auto rounded-md object-contain" />
          <span className="hidden font-mono text-[10px] uppercase tracking-[0.3em] text-[#22D3EE] sm:block">A QSI Product</span>
        </button>
        <nav className="hidden items-center gap-7 md:flex" aria-label="Main">
          {LINKS.map(([l, id]) => (
            <button key={id} data-testid={`lp-nav-${id}`} onClick={() => go(id)} className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-300 transition-colors hover:text-[#22D3EE]">{l}</button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button data-testid="lp-signin" onClick={onSignIn} className="rounded-full px-4 py-2 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-white transition-colors hover:text-[#22D3EE]">Sign In</button>
          <GreenButton data-testid="lp-header-free" onClick={onFree} className="hidden px-4 py-2 text-[10px] sm:inline-flex">Get Free Access</GreenButton>
          <button data-testid="lp-menu-toggle" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} onClick={() => setOpen(!open)} className="rounded-md p-2 text-slate-300 md:hidden">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="lp-mobile-menu" className="border-t border-white/5 bg-black/95 px-4 py-3 md:hidden" aria-label="Mobile">
          {LINKS.map(([l, id]) => (
            <button key={id} data-testid={`lp-mnav-${id}`} onClick={() => go(id)} className="block w-full py-3 text-left font-mono text-xs uppercase tracking-[0.2em] text-slate-200">{l}</button>
          ))}
          <GreenButton data-testid="lp-mnav-free" onClick={() => { setOpen(false); setTimeout(onFree, 60); }} className="mt-2 w-full">Get Free Access</GreenButton>
        </nav>
      )}
    </header>
  );
};
